import { Tooltip } from 'primereact/tooltip';
import React from 'react';

type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

type ToolTipFieldProps = {
    fieldName: string;
    index: number | string | undefined;
    value: string | number | null | undefined;
    showOnDisabled?: boolean;
    positionTooltip?: TooltipPosition;
};

const ToolTipField: React.FC<ToolTipFieldProps> = ({
    fieldName,
    index,
    value,
    children,
    positionTooltip = 'bottom'
}) => {
    const elementId = `${fieldName}-${index ?? 'default'}`;

    const hasValue =
        value !== null &&
        value !== undefined &&
        value !== '' &&
        (!(Array.isArray(value)) || value.length > 0);

    return (
        <span id={elementId}>
            {children}
            {hasValue && (
                <Tooltip
                    target={`#${elementId}`}
                    position={positionTooltip}
                >
                    {Array.isArray(value) ? value.join(', ') : value}
                </Tooltip>
            )}
        </span>
    );
}

export default ToolTipField
